module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('m-header', {
    attrs: {
      "title": "中奖详情"
    }
  }), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "detai-box text-l"
  }, [_c('div', {
    staticClass: "flex top vux-1px-b"
  }, [_c('div', {
    staticClass: "logo-top"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.shopInfo.shop_logo,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }, [_vm._v(_vm._s(_vm.data.shopInfo.shopname))]), _vm._v(" "), _c('span', {
    staticClass: "public-red"
  }, [_vm._v(_vm._s(_vm._f("statusName")(_vm.data.status)))])]), _vm._v(" "), _c('div', {
    staticClass: "flex info"
  }, [_c('div', {
    staticClass: "img"
  }, [_c('img', {
    staticClass: "img-block",
    attrs: {
      "src": _vm.data.image,
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "flex-1"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.data.title))]), _vm._v(" "), _c('p', {
    staticClass: "public-gray"
  }, [_vm._v(_vm._s(_vm.data.spec_info) + " "), _c('span', {
    staticClass: "fr"
  }, [_vm._v("X" + _vm._s(_vm.data.number))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex btn-box"
  })]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "logistics text-l"
  }, [_c('div', {
    staticClass: "title vux-1px-b"
  }, [_vm._v("物流信息")]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.logi.original)
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54f5f2e2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UserCenter/winning/winningDetail.vue
// module id = 562
// module chunks = 0